'use strict';

if (typeof module !== 'undefined') module.exports = simpleheat;


function simpleheat(canvasId,wrapperId,size) {
    if (!(this instanceof simpleheat)) return new simpleheat(canvasId,wrapperId,size);

    this.dpr = 1;
    this.chartSize = size > 1140 ? 1140 : size;
    this.chartRate = this.chartSize / 1140;
    this.CANVASWIDTH = this.chartSize * this.dpr;
    this.CANVASHEIGHT = this.chartSize / 1.5 * this.dpr;
    this.labelFamily = "NeueMontreal";

    this.margins = {
            top: 0.087 * this.CANVASHEIGHT,
            bottom: 0.086 * this.CANVASHEIGHT,
            left: 0.084 * this.CANVASWIDTH,
            rigth: 0.079 * this.CANVASWIDTH
        };

    this._canvas = document.getElementById(canvasId);
    this._width = this.CANVASWIDTH - this.margins.left - this.margins.rigth;
    this._height = this.CANVASHEIGHT - this.margins.top - this.margins.bottom;
    this._canvas.width = this.CANVASWIDTH;//actual width of canvas
    this._canvas.height = this.CANVASHEIGHT;//actual height of canvas
    this._canvas.style.width = this.CANVASWIDTH / this.dpr + "px";//actual width of canvas
    this._canvas.style.height = (this.CANVASHEIGHT / this.dpr) + "px";;//actual height of canvas
    this._ctx = this._canvas.getContext('2d');

    this._max = 1;
    this._data = [];
}

simpleheat.prototype = {

    defaultRadius: 30 * this.dpr,

    defaultGradient: {
        0.4: 'blue',
        0.6: 'cyan',
        0.7: 'lime',
        0.8: 'yellow',
        1.0: 'red'
    },

    data: function (data) {
        this._data = data;
        return this;
    },

    max: function (max) {
        this._max = max;
        return this;
    },

    add: function (point) {
        this._data.push(point);
        return this;
    },

    clear: function () {
        this._data = [];
        return this;
    },

    clearCanvas: function () {
        this._data = [];
        var ctx = this._canvas.getContext('2d');
        ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
        return this;
    },

    renderGamePrompt: function (homeTeam, awayTeam, homeTeamScore, awayTeamScore, homeTeamColor, awayTeamColor) {
      var context = this._canvas.getContext('2d');
      context.globalAlpha = 1;
      context.beginPath();
      context.fillStyle = homeTeamColor;
      context.rect(0.087 * 890 * this.dpr, 0, 0.022 * 890 * this.dpr, 0.07 * 597 * this.dpr);
      context.fill();

      context.fillStyle = "white";
      context.textAlign = "left";
      context.font = `bold ${26 * this.dpr * this.chartRate}px ${this.labelFamily}`;
      context.fillText(homeTeam + " · " + homeTeamScore, 105 * this.dpr, 35 * this.dpr);

      context.beginPath();
      context.fillStyle = awayTeamColor;
      context.rect(0.895 * 890 * this.dpr, 0, 0.022 * 890 * this.dpr, 0.07 * 597 * this.dpr);
      context.fill();

      context.fillStyle = "white";
      context.textAlign = "right";
      context.font = `bold ${26 * this.dpr * this.chartRate}px ${this.labelFamily}`;
      context.fillText(awayTeamScore + " · " + awayTeam, 790 * this.dpr, 35 * this.dpr);

      return this;
    },

    renderGamePlayerPrompt: function (playerName, playerPosition, playerMinutes) {
      var context = this._canvas.getContext('2d');
      context.globalAlpha = 1;
      context.beginPath();
      context.fillStyle = "white";
      context.textAlign = "center";
      context.font = `${17 * this.dpr * this.chartRate}px ${this.labelFamily}`;
      context.fillText(playerName + " · " + playerPosition + " · " + playerMinutes + " minutes", 452 * this.dpr, 580 * this.dpr);

      return this;
    },

    renderPlayerPrompt: function (playerName, seasonName) {
      var context = this._canvas.getContext('2d');
      context.fillStyle = "white";
      context.textAlign = "left";
      context.font = `bold ${18 * this.dpr * this.chartRate}px ${this.labelFamily}`;
      //Set alpha channel to 1 to legend doesn't depend on Blur slider
      context.globalAlpha = 1;
      context.fillText(playerName + " · " + seasonName, 78 * this.dpr, 40 * this.dpr);

      return this;
    },

    renderLogo: function (logo, darkMode) {
      var context = this._canvas.getContext('2d');
      if (logo == "eljurasico") {
        var img = new Image();
        img.onload = function () {
          context.drawImage(img, 0.785 * this.CANVASWIDTH, 0.85 * this.CANVASHEIGHT, 0.06 * 3.5 * this.CANVASHEIGHT, 0.06 * this.CANVASHEIGHT);
        };
        img.src = darkMode === true ? "/resources/img/eljurasico_dark.png" : "/resources/img/eljurasico.png";
      }
      if (logo == "driblab") {
        let img = new Image();
        img.onload = () => {
          context.drawImage(img, 0.735 * this.CANVASWIDTH, 0.805 * this.CANVASHEIGHT,
            0.06 * 4.3 * this.CANVASHEIGHT, 0.1 * this.CANVASHEIGHT);
        };
        img.src = darkMode === true? "/resources/img/driblab.png" : "/resources/img/driblab_white.png";
      }
      if (logo === "driblabNacional") {

          let driblabImage = new Image();
          let nacionalImage = new Image();

          //Load source image
          driblabImage.src = darkMode === true ? "/resources/img/driblab.png" : "/resources/img/driblab_white.png";
          nacionalImage.src = darkMode === true ? "/resources/img/el_nacional_dark.png" : "/resources/img/el_nacional_white.png";

          //Driblab Logo
          driblabImage.onload = () => {
              context.drawImage(driblabImage, 0.74 * this.CANVASWIDTH, 0.805 * this.CANVASHEIGHT, 0.06 * 4.3 * this.CANVASHEIGHT, 0.1 * this.CANVASHEIGHT);
          };

          //Nacional Logo
          nacionalImage.onload = () => {
              context.drawImage(nacionalImage, 0.1 * this.CANVASWIDTH, 0.8 * this.CANVASHEIGHT, 0.13 * this.CANVASHEIGHT, 0.12 * this.CANVASHEIGHT);
          };

      }
    },

    radius: function (r, blur) {
        blur = blur === undefined ? 50 * this.dpr : blur * this.dpr;
        // create a grayscale blurred circle image that we'll use for drawing points
        this._circle = this._createCanvas();
        var ctx = this._circle.getContext('2d'),
            r2 = this._r = r + blur;

        this._circle.width = this._circle.height = r2 * 2;
        this._circle.setAttribute("width",this._circle.width);
        this._circle.setAttribute("height",this._circle.height);
        this._circle.style.width = this._circle.width + "px";
        this._circle.style.height = this._circle.height + "px";

        ctx.shadowOffsetX = ctx.shadowOffsetY = r2 * 2;
        ctx.shadowBlur = blur;
        ctx.shadowColor = 'black';

        ctx.beginPath();
        ctx.arc(-r2, -r2, r, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return this;
    },

    resize: function () {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },

    gradient: function (grad) {
        // create a 256x1 gradient that we'll use to turn a grayscale heatmap into a colored one
        var canvas = this._createCanvas(),
            ctx = canvas.getContext('2d'),
            gradient = ctx.createLinearGradient(0, 0, 0, 256);

        canvas.width = 1;
        canvas.height = 256;

        for (var i in grad) {
           gradient.addColorStop(+i, grad[i]);
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1, 256);

        this._grad = ctx.getImageData(0, 0, 1, 256).data;

        return this;
    },

    draw: function (minOpacity) {
        if (!this._circle) this.radius(this.defaultRadius);
        if (!this._grad) this.gradient(this.defaultGradient);

        var ctx = this._ctx;

        // ctx.clearRect(0, 0, this._width, this._height);

        // draw a grayscale heatmap by putting a blurred circle at each data point
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];
            ctx.globalAlpha = Math.max(p[2] / this._max, minOpacity === undefined ? 0.5 : minOpacity);
            ctx.drawImage(this._circle, p[0] * this.dpr - this._r, p[1] * this.dpr - this._r);
        }

        // colorize the heatmap, using opacity value of each pixel to get the right color from our gradient
        var colored = ctx.getImageData(0, 0, this.CANVASWIDTH , this.CANVASHEIGHT);
        this._colorize(colored.data, this._grad);
        ctx.putImageData(colored, 0, 0);

        return this;
    },

    _colorize: function (pixels, gradient) {
        for (var i = 0, len = pixels.length, j; i < len; i += 4) {
            j = pixels[i + 3] * 4; // get gradient color from opacity value

            if (j) {
                pixels[i] = gradient[j];
                pixels[i + 1] = gradient[j + 1];
                pixels[i + 2] = gradient[j + 2];
            }
        }
    },

    _createCanvas: function () {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};

exports.simpleheat = simpleheat; 


// WEBPACK FOOTER //
// ./src/utils/simpleheat.js